import * as types from '../../mutation-types'
import auth from './auth'
import dashboard from './dashboard'
import users from './users'
import imports from './imports'
import syncs from './syncs'
import visits from './visits'

const state = {
  items: [
    auth,
    dashboard,
    users,
    imports,
    syncs,
    visits
  ]
}

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM] (state, payload) {
    let menuItem = payload.menuItem
    let expand = payload.expand
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand
    }
  }
}

const actions = {
  toggleExpandMenuItem ({commit}, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js